import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Badge, Card, CardBody } from "reactstrap";
import FilterTable from "./FilterTable";

import { useProductList } from "hooks/product/useProduct";

const ProductPage = () => {
  const { t: ts } = useTranslation(["product"]);
  const initParams = () => {
    return {
      sizePerPage: 10,
      page: 1,
      columnFilter: {
        "filter[visible]": 1,
      },
      keywords: "",
      run: false,
      sort: "-maker_date",
    };
  };

  const [productListParams, setProductListParams] = useState(initParams);
  const {
    data: productList,
    refetch: fetchProductList,
    isLoading: isLoadingProductList,
  } = useProductList({
    params: {
      ...productListParams,
      columnFilter: {
        ...productListParams.columnFilter,
        group: undefined,
        record_status: undefined,
      },
    },
  });

  const cols = [
    {
      dataField: "id",
      text: ts("table.no"),
      formatter: (cell, row, enumObject) => {
        return `${enumObject + 1}`;
      },
    },
    {
      dataField: "slug",
      text: ts("table.slug"),
    },
    {
      dataField: "name",
      text: ts("table.name"),
    },
    {
      dataField: "commercial_name",
      text: ts("table.commercial_name"),
    },
    {
      dataField: "group",
      text: ts("table.group"),
    },
    {
      dataField: "record_status",
      text: ts("table.status"),
      headerAlign: "center",
      align: "center",
      formatter: (cell, row) => {
        if (cell === "O") {
          return (
            <Badge color="success" pill>
              {ts("actions.active")}
            </Badge>
          );
        } else {
          return (
            <Badge color="danger" pill>
              {ts("actions.un_active")}
            </Badge>
          );
        }
      },
    },
    {
      dataField: "visible",
      text: ts("table.visible"),
      headerAlign: "center",
      align: "center",
      formatter: (cell, row) =>
        cell === 1 ? (
          <i className="fas fa-check-circle text-primary fs-5"></i>
        ) : (
          <></>
        ),
    },
  ];

  const onTableChangeProduct = useCallback((_type, value) => {
    setProductListParams(prev => ({
      ...prev,
      page: value.page,
      sizePerPage: value.sizePerPage,
    }));
  }, []);

  const onSearchAllHandle = useCallback(value => {
    setProductListParams(prev => ({
      ...prev,
      keywords: value,
    }));
  }, []);

  useEffect(() => {
    fetchProductList();
    return () => {};
  }, [productListParams]);

  return (
    <div className="page-content">
      <MetaTags>
        <title>{ts("title.manager")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={
            ts("title.list", { target: ts("product") }) +
            ` (${productList?.meta?.totalCount || 0})`
          }
          breadcrumbItems={[
            { name: ts("title.manager") },
            { name: ts("title.list", { target: ts("product") }) },
          ]}
        />
        <Card>
          <CardBody>
            <RemoteDataTable
              keyField="id"
              data={productList?.items || []}
              columns={cols}
              isShowRowIndex={false}
              loading={isLoadingProductList}
              onTableChange={onTableChangeProduct}
              page={productList?.meta?.currentPage}
              totalSize={productList?.meta?.totalCount}
              searchSticky
              sizePerPage={productList?.meta?.perPage}
              onSearchAllHandle={onSearchAllHandle}
            >
              <FilterTable
                productListParams={productListParams}
                setProductListParams={setProductListParams}
              />
            </RemoteDataTable>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ProductPage;
